import React, {useContext} from 'react';
import SimpleContext from '../context/SimpleContext';
import Iframe from 'react-iframe';
import cross from "../img/cross.png";
import { useHistory } from 'react-router';

const Link = () => {

    const context = useContext(SimpleContext);
    const history = useHistory()
    return ( 
        <div style={{display:"flex",flexDirection:'column',gapL:"10px",width:'100%'}}>
        <div style={{justifyContent:'flex-start',padding:'5px'}} className="otherPagesHeader">
             <img onClick={()=>history.go(-1)} style={{width:'20px'}} src={cross}/> 
        </div>
        <div style={{marginTop:'60px'}}>
        <Iframe url={context.TextPopUp.link}
        width="100%"
        height="900"
        id=""
        className=""
        display="block"
        position="relative"/>
        </div>
        </div>
    )}
 
export default Link;